import { NoSymbolIcon } from '@heroicons/react/24/outline'
import { ContentAction, ContentActionView, ContentView } from '../../../api/client'
import ActionGenericButton from './GenericActionButton'

type Props = {
    content: ContentView
    onActionClick: (actions: ContentActionView[], queued?: boolean) => void
    actions: ContentActionView[]
    disabled?: boolean
    disabledMessage?: string
}

export default function BlockButton(props: Props) {
    const { content, onActionClick, actions, disabled, disabledMessage } = props

    return (
        <ActionGenericButton
            content={content}
            onActionClick={onActionClick}
            action={ContentAction.Block}
            tooltip="Block/unblock this user"
            colour="red"
            icon={<NoSymbolIcon />}
            actions={actions}
            disabled={disabled}
            disabledMessage={disabledMessage}
        />
    )
}
